export default __webpack_public_path__ + "f28a6270a109a70682907b2df5353deb.png";